import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_DentalV1GetsafeDe } from '@flows/insurance/schemas'

const dental_birthday = (params: StepConfigParams) => {
  return {
    schema: BaseSchema_DentalV1GetsafeDe.pick({ born_on: true }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_birthday.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        autoFocus: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'dental_health_insurance_type',
  } as const satisfies AnyStepConfiguration
}

export default dental_birthday
